module.exports = __webpack_public_path__ + "static/media/LTNT_Logo_Mythic_Icon.56a73ef7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/LTNT_Logo_Mythic_Icon.svg
// module id = 812
// module chunks = 0